<script>
export default {
  name: 'VolanGroup',
  props: {
    // v-model opcional do estado colapsado. Sem type para que a ausência
    // seja `undefined` (e não sofra o cast de Boolean para `false`),
    // permitindo cair no fallback de `startCollapsed`.
    value: {
      default: undefined,
    },
    hasCollapse: {
      type: Boolean,
      default: false
    },
    startCollapsed: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    hideHeader: {
      type: Boolean,
    }
  },
  data(vm) {
    return {
      internalCollapsed: typeof vm.value === 'boolean' ? vm.value : vm.startCollapsed,
    };
  },
  computed: {
    isCollapsed: {
      get() {
        return this.internalCollapsed;
      },
      set(val) {
        if (val === this.internalCollapsed) {
          return;
        }
        this.internalCollapsed = val;
        this.$emit('input', val);
      },
    },
  },
  watch: {
    value(val) {
      if (typeof val === 'boolean' && val !== this.internalCollapsed) {
        this.internalCollapsed = val;
      }
    },
  },
  methods: {
    clickHeader(event) {
      event.preventDefault();
      if (this.hasCollapse) {
        this.isCollapsed = !this.isCollapsed;
      }
    }
  }
};
</script>

<template>
  <div class="form-group bordered-group mb-8">
    <div v-if="!hideHeader" class="header-group bordered-bottom" @click="clickHeader">
      <div class="label-area">
        <span v-if="title">{{ title }}</span>
        <VSpacer />
        <slot name="header" />
        <VBtn v-if="hasCollapse"
              class="BtnIcon"
              small
              icon
        >
          <VIcon v-if="isCollapsed">
            mdi-chevron-up
          </VIcon>
          <VIcon v-else>
            mdi-chevron-down
          </VIcon>
        </VBtn>
      </div>
    </div>
    <div v-if="!isCollapsed" class="form-group-body">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .label-area {
    display: flex;
  }
  .form-group-body {
    padding: 12px;
  }
</style>
